import { markRung } from '../../lib/championToClose.js'
import styles from './MarkRung.module.css'

/**
 * WHICH RUNG THIS ASSET IS ON, IN WORDS, WHEREVER THE ASSET APPEARS.
 *
 * ⚠️ THE FAILURE THIS PREVENTS is somebody emailing a sketch to a coach
 * believing it is a proof. The three rungs look more alike the better the
 * middle one gets: a real crest on a generated housing reads as finished
 * artwork at a glance, and it is the most dangerous of the three for exactly
 * that reason. So the badge never shows a field value, it shows the word a
 * person would use, and it always carries the SENDABLE verdict beside it
 * rather than leaving that to be inferred.
 *
 * `markRung` fails closed: an unknown, empty or forged value renders as
 * Sketch, never as Proof. See championToClose.js.
 *
 * ⚠️ AND THE BADGE IS NOT A GATE. It reports; it does not enforce. The gate is
 * `isAttachableSurface`. Saying "the platform stops you sending this" would be
 * a claim this component cannot keep.
 */
export default function MarkRung({ markSource, detail = '', compact = false }) {
  const r = markRung(markSource)
  return (
    <div className={`${styles.wrap} ${compact ? styles.compact : ''}`} data-rung={r.rung}>
      <span className={styles.badge} data-send={r.rung === 3 ? 'yes' : 'no'}>
        <span className={styles.rungNo}>{r.rung} of 3</span>
        <strong className={styles.label}>{r.label}</strong>
      </span>
      {!compact && (
        <span className={styles.text}>
          <span className={styles.what}>{r.what}</span>
          {/* ⚠️ THE VERDICT LINE CHANGED ON 2026-09-19 AND THE BADGE DID NOT
            * STOP MATTERING. All three rungs may now be sent, so this no longer
            * says whether you MAY: it says WHAT YOU ARE SENDING. That is the
            * whole job of the badge now that the block is gone. */}
          <span className={r.rung === 3 ? styles.canSend : styles.cannotSend}>
            {r.rung === 3 ? 'This is a proof. ' : 'This is a concept, not a proof. '}
            {r.why}
          </span>
          {detail && <span className={styles.detail}>{detail}</span>}
        </span>
      )}
    </div>
  )
}
